import { render } from "./EmployeePayslip.vue?vue&type=template&id=0570763e"
import script from "./EmployeePayslip.vue?vue&type=script&lang=js"
export * from "./EmployeePayslip.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__